<app-comments-list entityType="task" [entityId]="taskId">
  <app-empty-table type="CommentsList"></app-empty-table>
</app-comments-list>
